import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const points = ['Domingo a la noche buscando material que no se adapta al alumno argentino.', 'Llegás al lunes con actividades sin estructura, sin cierre y sin rúbrica.', 'Planificaciones armadas a las corridas la noche anterior.', 'Evaluaciones siempre iguales, sin banco de instrumentos ni feedback listo.', 'Temas difíciles como el subjuntivo, los falsos amigos o la fonética, sin saber cómo arrancarlos.', 'Alumnos de distintos niveles en el mismo grupo y sin material diferenciado.', 'Cada domingo volvés a empezar el ciclo de buscar, armar e improvisar.'];
  return <section className="w-full bg-white py-20 px-4" data-id="element-224">
      <div className="max-w-3xl mx-auto" data-id="element-225">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center text-deep-green mb-12 leading-tight" data-id="element-226">
          Si sos docente de Português en Argentina, esto te va a sonar familiar:
        </motion.h2>

        <div className="space-y-6 mb-16" data-id="element-227">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4" data-id="element-228">
              <span className="text-xl mt-0.5 flex-shrink-0" data-id="element-229">❌</span>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-230">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-231">
          <h3 className="text-2xl md:text-3xl font-bold text-deep-green mb-10" data-id="element-232">
            ¿Cuántos domingos más vas a perder haciendo lo mismo?
          </h3>

          {/* Extra Mid-Page CTA as requested */}
          <motion.button onClick={scrollToPricing} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} animate={{
          boxShadow: ['0px 0px 0px rgba(245,158,11,0)', '0px 0px 20px rgba(245,158,11,0.5)', '0px 0px 0px rgba(245,158,11,0)']
        }} transition={{
          boxShadow: {
            duration: 2,
            repeat: Infinity
          }
        }} className="w-full md:w-auto bg-gold hover:bg-yellow-500 text-deep-green font-extrabold text-lg py-4 px-8 rounded-lg shadow-lg transition-colors" data-id="element-233">
            👉 BASTA DE DOMINGOS PERDIDOS — VER EL PACK COMPLETO
          </motion.button>
        </motion.div>
      </div>
    </section>;
}